import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Defect } from '@/types';
import { useGetDefectsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchDefects<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Defect> } & Omit<
  AutocompleteProps<Defect, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetDefectsQueryProps = useAsyncSearch<Defect, Multiple, DisableClearable, FreeSolo>(
    useGetDefectsQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetDefectsQueryProps} />;
}

export default SearchDefects;
